export default "__VITE_ASSET__Bx$C2Tr8__"